import { TAG_TYPES } from '../constants';
import type { projectOrchestratorApi } from '../rtk.generated';

type ProjectOrchestratorApi = typeof projectOrchestratorApi;

export const enhance = (api: ProjectOrchestratorApi) => {
  return api.enhanceEndpoints({
    endpoints: {
      getProjectsByProjectIdRecruitassignmentsLatest: {
        providesTags: () => [TAG_TYPES.RECRUIT_ASSIGNMENT],
      },
      getProjectsByProjectIdRecruitprogress: {
        providesTags: () => [TAG_TYPES.RECRUIT_PROGRESS],
      },
      postFilteredProfileCsv: {
        query: (queryArg) => ({
          url: `/FilteredProfile/$csv`,
          method: 'POST',
          body: queryArg.filterProfileRequest,
          responseHandler: async (response) => response.text(),
        }),
      },
    },
  });
};
